module.exports = __webpack_public_path__ + "img/C04TechSpearman2_ua.97e35303.webp";